import { useEffect, useState } from 'react';
import orgService from '../../../services/orgService';
import { useUser } from '../../authentication';
import licenseService from '../../../services/licenseService';
import { Training } from '../models/training';
import { UserTrainingAccess } from '../models/UserTrainingAccess';
import { isCourse } from '../utils/isCourse';
export const useTrainingAccess = (training?: Training): UserTrainingAccess => {
  const user = useUser();
  const orgId = user?.lastSelectedAccount;

  const [hasIndividualGridSubscription, setHasIndividualGridSubscription] = useState(false);
  const [hasGridSubscription, setHasGridSubscription] = useState(false);
  const [hasIndividualLicenseForItem, setHasIndividualLicenseForItem] = useState(false);
  const [canAccessWithoutSubscription, setCanAccessWithoutSubscription] = useState(false);
  const [canAccess, setCanAccess] = useState(false);
  const [hasPaidForCourse, setHasPaidForCourse] = useState(false);
  const isAdmin = user?.permissions?.includes('Account View') ?? false;
  const hasAssignPermission = user?.permissions?.includes('Assign View') ?? false;
  const isGroupLeader = user?.permissions?.includes('Group Leader') ?? false;
  const canAssign = hasAssignPermission || isGroupLeader || isAdmin;

  useEffect(() => {
    if (training && orgId) {
      orgService.hasIndividualSubscription(orgId).then((hasIndividualGridSubscription: boolean) => {
        setHasIndividualGridSubscription(hasIndividualGridSubscription);
      });

      licenseService.getPairedLicenses(orgId).then((licenses: { isGridSubscription: boolean; expired: boolean }[]) => {
        const subscriptionNotNeeded = ['A21'].includes(window.location.origin);

        const userHasGridSubscription =
          licenses.filter(function (license) {
            return license.isGridSubscription && !license.expired;
          }).length > 0;
        setHasGridSubscription(userHasGridSubscription);

        setCanAccessWithoutSubscription(subscriptionNotNeeded);

        setCanAccess(
          (training.searchAccess === 'Paid' && userHasGridSubscription) ||
            subscriptionNotNeeded ||
            (training.searchAccess === 'Free' && !!orgId)
        );
      });
    }
  }, [orgId, training]);

  useEffect(() => {
    if (training) {
      setHasPaidForCourse(!(isCourse(training) && !training?.hasAccess && !training?.isIncludedWithGridSubscription));

      if (training.searchAccess === 'Paid') {
        licenseService
          .getIndividualLicenses()
          .then((licenses: { seats: { isPermanent: boolean; isLimited: boolean } }[]) => {
            setHasIndividualLicenseForItem(
              licenses.filter(function (license) {
                return license.seats && license.seats.isPermanent && license.seats.isLimited;
              }).length > 0
            );
          });
      }
    }
  }, [training]);

  return {
    isAdmin,
    hasAssignPermission,
    isGroupLeader,
    canAssign,
    hasIndividualGridSubscription,
    hasGridSubscription,
    hasIndividualLicenseForItem,
    hasPaidForCourse,
    canAccessWithoutSubscription,
    canAccess,
  };
};
